import shippingOptions from '../../data/shippingOptions.json';
import { shippingCarrierValues } from '../../data/shippingCarriers';
import { validDeliveryDay } from '../../services/shippingService';

/** The mobile and web order forms both limit a submission to ten product lines. */
export const MAX_LINE_ITEMS = 10;

/**
 * Build the existing CreateOrderDto without changing its legacy field names.
 * `patientName` remains the API key for the optional Customer PO value.
 */
export function buildOrderPayload({
  patientName,
  lineItems,
  address,
  addressCity = '',
  addressState = '',
  addressZipCode = '',
  deliveryDate,
  shippingSpeed,
  preferredCarrier = 'fedex',
  shippingScheduleVersion,
  comment,
  clinic,
}) {
  const payload = {
    patientName: patientName.trim(),
    lineItems: lineItems.map((item) => ({
      product: item.product,
      quantity: parseInt(item.quantity, 10),
      size: item.size,
    })),
  };

  const location = {
    street: address.trim(),
    city: addressCity.trim(),
    state: addressState.trim(),
    zipCode: addressZipCode.trim(),
  };

  if (shippingScheduleVersion === 1 && Object.values(location).some(Boolean)) {
    if (!Object.values(location).every(Boolean)) {
      throw new Error('Enter the complete delivery address.');
    }
    payload.address = location;
  } else if (address.trim()) {
    payload.address = { street: address.trim() };
  }

  if (deliveryDate) {
    if (shippingScheduleVersion === 1) {
      if (!validDeliveryDay(deliveryDate)) {
        throw new Error('Select a valid delivery date.');
      }
      payload.deliveryDate = deliveryDate;
    } else {
      payload.deliveryDate = new Date(`${deliveryDate}T00:00:00`).toISOString();
    }
  }

  if (shippingSpeed && !shippingOptions.includes(shippingSpeed)) {
    throw new Error('Select a weekday shipping service.');
  }
  if (shippingSpeed) payload.shippingSpeed = shippingSpeed;
  if (!shippingCarrierValues.includes(preferredCarrier)) throw new Error('Choose FedEx or UPS.');
  payload.preferredCarrier = preferredCarrier;

  if (shippingScheduleVersion === 1) {
    if (!shippingSpeed || !validDeliveryDay(deliveryDate)) {
      throw new Error('Review the delivery details.');
    }
    payload.shippingScheduleVersion = 1;
  }

  if (comment.trim()) payload.comment = comment.trim();
  if (clinic) payload.clinic = clinic;

  return payload;
}

/**
 * Resolve the product size already encoded at the end of a product name.
 * Longest match wins so a size such as 2x2x2 is not mistaken for 2x2.
 */
export function sizeFromProductName(name, sizes) {
  const normalizedName = String(name || '')
    .trim()
    .toLowerCase();
  if (!normalizedName) return '';

  const matches = (sizes || [])
    .map(String)
    .filter((size) => normalizedName.endsWith(size.trim().toLowerCase()))
    .sort((left, right) => right.trim().length - left.trim().length);

  return matches[0] || '';
}
